var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-wrapper"},[_c('i',{class:{
      'icon-outline_info': !_vm.hover,
      'icon-fill_info': _vm.hover,
    },attrs:{"id":`${_vm.name}-tooltip`},on:{"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}}),_c('b-tooltip',{attrs:{"target":`${_vm.name}-tooltip`,"triggers":"hover","placement":"rightbottom"}},[_vm._v(" "+_vm._s(_vm.tooltipText[_vm.name])+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }